import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';

type ColorMap = { [key: string]: ChipProps['color'] };

const colorMap: ColorMap = {
  [TsrctNegotiationCaseStatus.AGREEMENT_REACHED]: 'success',
  [TsrctNegotiationCaseStatus.NO_AGREEMENT_REACHED]: 'error',
  [TsrctNegotiationCaseStatus.OFFER_DISMISSED]: 'error',
  [TsrctNegotiationCaseStatus.AGREEMENT_CONFIRMED]: 'success',
  [TsrctNegotiationCaseStatus.AWARDED]: 'success',
  [TsrctNegotiationCaseStatus.MANUAL_NEGOTIATION]: 'warning',
};

export interface NegotiationStatusChipProps {
  className?: string;
  status?: keyof typeof TsrctNegotiationCaseStatus;
}

export const NegotiationStatusChip = ({ className, status }: NegotiationStatusChipProps) => {
  const { t } = useTranslation();
  return status ? (
    <Chip
      className={className}
      label={t(`NegotiationStatus.${status}`)}
      color={colorMap[status]}
      data-intercom-target="Negotiation/StatusChip"
      data-testid="Negotiation/StatusChip"
      title={t(`NegotiationStatus.${status}`)}
    />
  ) : null;
};
